import React, { useMemo } from 'react';

import classnames from 'classnames/bind';

import { AdminSingleSectionData, AdminSingleSectionMeta } from '@INTERFACES/admin-api/sections';

import useSectionNameModal from '@HOOKS/store/modals/useSectionNameModal';
import useDocumentStructureHelpModal from '@HOOKS/store/modals/useDocumentStructureHelpModal';
import useDocumentPermissions from '@HOOKS/useDocumentPermissions';
import BasicButton from '@COMPONENTS/COMMON/buttons/BasicButton';
import TagsComponent from '@COMPONENTS/COMMON/tags/tags.component';
import {
    useAddTagToSection, useCreateAndAddTagToSection, useDeleteTagFromSection, useGetAllTags,
} from '@SERVICES';
import useDeleteSectionModal from '@HOOKS/store/modals/useDeleteSectionModal';
import { useNavigate } from 'react-router-dom';
import styles from './SectionName.module.scss';

const cx: CX = classnames.bind(styles);

function SectionName(props: Props) {
    const {
        sectionData, sectionMeta, actionButton, bodyCotent,
    } = props;

    const navigate = useNavigate();

    const {
        canEditDocument,
        canManageDocumentTags,
        canPublishDocument,
    } = useDocumentPermissions({
        documentOwnerId: sectionData.document.owner,
        permissions: sectionMeta.permissions,
    });

    const {
        actions,
    } = useSectionNameModal(() => true);

    const {
        actions: documentStructureHelpModalActions,
    } = useDocumentStructureHelpModal(() => true);

    const [deleteTag, deleteTagResult] = useDeleteTagFromSection();
    const [addTagToSection, addTagToSectionResult] = useAddTagToSection();
    const [createAndAddTagToVariant, createAndAddTagToVariantResult] = useCreateAndAddTagToSection();

    const {
        actions: deleteSectionActions,
    } = useDeleteSectionModal(() => true);

    const handleDeleteSection = () => {
        deleteSectionActions.open(
            {
                id: sectionData.id,
                name: sectionData.name,
                chapterId: sectionData.chapter.id,
                documentId: sectionData.document.id,
            },
            () => navigate(-1),
        );
    };

    const handleOpenHelpModal = () => {
        documentStructureHelpModalActions.open();
    };

    return (
        <div className={cx('section-name', 'container')}>
            <div className={cx('content-wrapper')}>
                <div className={cx('title-section')}>
                    <div className={cx('name')}>
                        {`Section - ${sectionData?.name}`}
                    </div>
                    <div className={cx('title-actions')}>
                        <BasicButton
                            title="Delete"
                            variant="danger"
                            size="small"
                            icon="trash"
                            onClick={handleDeleteSection}
                            tooltip="Delete section"
                        />
                        {canEditDocument && (
                            <BasicButton
                                title="Rename"
                                variant="neutral"
                                size="small"
                                icon="edit"
                                onClick={() => {
                                    actions.open({
                                        sectionData,
                                    });
                                }}
                                tooltip="Edit section name"
                            />
                        )}
                        <BasicButton
                            title="Help"
                            variant="neutral"
                            size="small"
                            icon="help"
                            onClick={handleOpenHelpModal}
                            tooltip="How sections work"
                        />
                        {/* Removed PublishButton - keeping only the FloatingPublishButton for "Publish all changes" */}
                    </div>
                </div>
                <div className={cx('action-button-wrapper')}>
                    {actionButton}
                </div>
            </div>
            {bodyCotent && (
                <div className={cx('body-wrapper')}>
                    {/* <TagsComponent
                        locked={!canManageDocumentTags}
                        tags={sectionData.tags}
                        tagQuery={[deleteTag, deleteTagResult]}
                        apiParams={{
                            chapterId: sectionData.chapter.id,
                            id: sectionData.id,
                            documentId: sectionData.document.id,
                        }}
                        getAllTagsQuery={useGetAllTags}
                        getTagsParams={{
                            documentId: sectionData.document.id,
                        }}
                        addTagQuery={[addTagToSection, addTagToSectionResult]}
                        addTagParams={{
                            id: sectionData.id,
                            chapterId: sectionData.chapter.id,
                        }}
                        createAndAddTagQuery={[createAndAddTagToVariant, createAndAddTagToVariantResult]}
                        createAndAddTagParams={{
                            documentId: sectionData!.document!.id,
                            chapterId: sectionData!.chapter!.id,
                            id: sectionData!.id,
                        }}
                        sectionData={sectionData}
                    /> */}
                    {bodyCotent}
                </div>
            )}
        </div>
    );
}

type Props = {
    sectionData: AdminSingleSectionData,
    sectionMeta: AdminSingleSectionMeta,
    actionButton?: React.ReactNode,
    bodyCotent?: React.ReactNode
};

SectionName.defaultProps = {
    actionButton: null,
    bodyCotent: null,
};

export default SectionName;
